export const HIDDEN_PASSWORD_ERROR_MESSAGE = 'hiddenPasswordErrorMessage';
